import './styles.scss';

console.log('hello');



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/